<script>
    export default {
        props: [
            'stat', 'locale'
        ],
        data: function(){
            return {
                formatter: null,
                formatterInteger: null,
                isActulizedPast: false,
                ctx: null,
                chart: null,
                xAxes: [],
                colors: {},
                chartConfig: {},
                tableConfig: {},
            }
        },
        mounted: function(){
            var statisticChart = this;

            statisticChart.formatter = new Intl.NumberFormat(this.locale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            statisticChart.formatterInteger = new Intl.NumberFormat(this.locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });

            statisticChart.initDefaults();

            Event.$on("filterApplied", function(statisticFilter, data){
                if(statisticFilter.stat == statisticChart.stat){
                    statisticChart.draw(statisticFilter, data);
                    statisticChart.$parent.loading = false;
                }
            });

            Event.$on('actualizePastChanged', function (statisticFilter, event) {
                if(statisticFilter.stat == statisticChart.stat){
                    statisticChart.actualizePastChanged(statisticFilter);
                }
            });

            Event.$on('maximizeToggle', function (statistic, event) {
                if(statistic.stat == statisticChart.stat){
                    statisticChart.adjustInterface();
                }
            });

        },
        methods: {
            initDefaults: function() {
                var statisticChart = this;

                statisticChart.ctx = $('.widget--statistic__chart-canvas', statisticChart.$el).get(0).getContext('2d');

                statisticChart.colors = {
                    white: 'rgb(255, 255, 255)',
                    black: 'rgb(0, 0, 0)',
                    red: 'rgb(255, 99, 132)',
                    orange: 'rgb(255, 159, 64)',
                    yellow: 'rgb(255, 205, 86)',
                    green: 'rgb(75, 192, 192)',
                    blue: 'rgb(54, 162, 235)',
                    purple: 'rgb(153, 102, 255)',
                    grey: 'rgb(201, 203, 207)'
                };

                statisticChart.chartConfig = {
                    data: {
                        datasets: []
                    },
                    options: {
                        responsive: true,
                        legend: {
                            labels: {
                                boxWidth: 12,
                                usePointStyle: true
                            }
                        },
                        tooltips: {
                            mode: 'index',
                            position: 'average',
                            callbacks: {
                                title: function(tooltipItems, data) {
                                    if(tooltipItems.length > 1){
                                        return [data.labels[tooltipItems[0].index][0], data.labels[tooltipItems[0].index][1]];
                                    }
                                    return data.labels[tooltipItems[0].index][0];
                                },
                                label: function(tooltipItem, data) {
                                    var value = statisticChart.formatter.format(tooltipItem.yLabel);
                                    return data.datasets[tooltipItem.datasetIndex].label +': ' + value + ' €';
                                },
                                footer: function(tooltipItems, data) {
                                    if(tooltipItems.length > 1){
                                        var delta = 0;

                                        if(data.datasets[1].data[tooltipItems[1].index] == 0 && data.datasets[0].data[tooltipItems[0].index] == 0){
                                            delta = 0;
                                        }else if(data.datasets[0].data[tooltipItems[0].index] == 0 && data.datasets[1].data[tooltipItems[1].index] != 0){
                                            delta = -100;
                                        }else if(data.datasets[0].data[tooltipItems[0].index] != 0 && data.datasets[1].data[tooltipItems[1].index] == 0){
                                            delta = data.datasets[0].data[tooltipItems[0].index];
                                        }else{
                                            delta = data.datasets[0].data[tooltipItems[0].index] - data.datasets[1].data[tooltipItems[1].index];
                                            delta = delta*100/data.datasets[1].data[tooltipItems[1].index];
                                        }

                                        return (delta >= 0 ? '▲ +' : '▼ ') + statisticChart.formatter.format(delta) + '%';
                                    }else{
                                        return;
                                    }
                                },
                            },
                            intersect: false,
                        },
                        hover: {
                            mode: 'nearest',
                            intersect: true
                        },
                        scales: {
                             xAxes: [{
                                id: 'main',
                                ticks: {
                                    fontColor: statisticChart.colors.green,
                                    maxRotation: 0,
                                    minRotation: 0,
                                    callback: function(label){
                                        var main = label[0];
                                        return main;
                                    }
                                }
                            }]
                        }
                    }
                };

                statisticChart.chart = new Chart(statisticChart.ctx, statisticChart.chartConfig);

                statisticChart.tableConfig = $.extend(true, {}, {
                    scrollY: '500px',
                    scrollCollapse: true,
                    mark: true,
                    scrollX: false,
                    dom: 'lBfrtip<"actions">',
                    buttons: [{
                            extend: 'excel',
                            text: window.excelButtonTrans,
                            exportOptions: {
                                columns: ':visible'
                            },
                            className: 'btn btn-info'
                        }
                    ],
                    language: {
                        url: '/js/vendor/dataTables/lang/' + $("html").attr("lang") + '.json'
                    },
                    drawCallback: function (settings) {
                        $('.dt-button', '.dataTables_wrapper').removeClass("dt-button");
                        statisticChart.adjustInterface();
                    },
                    initComplete: function(settings, json) {
                        statisticChart.adjustInterface();
                    }
                });
            },
            actualizePastChanged: function(statisticFilter){
                let statisticChart = this;

                if(statisticFilter.mainActualizePast){
                    statisticChart.isActulizedPast = true;
                }else{
                    statisticFilter.table = false;
                    statisticChart.isActulizedPast = false;
                }
            },
            tableDataFetch: function(event){
                let statisticChart = this;

                Event.$emit('tableDataFetch', statisticChart, event);
            },
            pad: function(num, size) {
                var s = num + "";
                while (s.length < size) s = "0" + s;
                return s;
            },
            buildAxesX: function (statisticFilter) {
                var statisticChart = this;
                statisticChart.xAxes = [];
                var index = 0;
                for(var year = statisticFilter.mainYearStart; year <= statisticFilter.mainYearEnd; year++){
                    var month_start = 1;
                    var month_end = 12;
                    if(year == statisticFilter.mainYearStart){
                        month_start = statisticFilter.mainMonthStart;
                    }
                    if(year == statisticFilter.mainYearEnd){
                        month_end = statisticFilter.mainMonthEnd;
                    }
                    for(var month = month_start; month <= month_end; month++){
                        var xAxesItem = statisticChart.pad(month, 2) + '/' + year;
                        statisticChart.xAxes[index] = [xAxesItem];
                        index++;
                    }
                }
            },
            adjustInterface: function(){
                var statisticChart = this;

                var dataTable = $(".widget--statistic__table", statisticChart.$el);

                if($.fn.dataTable.isDataTable(dataTable)){
                    dataTable.dataTable().api().columns.adjust();
                    $(".dataTables_scrollBody", statisticChart.$el).width(dataTable.width());
                }
            },
            draw: function (statisticFilter, data) {
                var statisticChart = this;
                console.log(data);
                statisticChart.buildAxesX(statisticFilter);

                switch(statisticFilter.stat) {
                    case 'super-commissions-personal':
                    case 'super-commissions-downline':
                        statisticChart.drawLineChart(statisticFilter, data, statisticChart.formatter.format, '€');
                        break;
                }

                statisticChart.drawTable(statisticFilter, data);

                statisticChart.chart.update();
                $(statisticChart.$el).closest('.statistic').find('.div-preloader').fadeOut();
            },
            drawTable: function(statisticFilter, data){
                var statisticChart = this;
                var dtColumns  = data.tableData.columns;
                var dtData = data.tableData.data;
                var dtMainTotal = data.tableData.mainTotal;
                var dtColumnDefs = data.tableData.columnDefs;
                var dtColumnsLength = dtColumns.length;
                var dtMainTotalColumn = dtColumnsLength - 3;
                var dtFilterColumn = data.tableData.filterColumn;
                var dtOrder = data.tableData.order;
                var dtTotalRow = false;
                var dtTotalRowSymbol = '€';
                var dtTotalRowFormatter = statisticChart.formatter.format;

                if(statisticFilter.table){
                    var dataTable = $(".widget--statistic__table", statisticChart.$el);

                    if($.fn.dataTable.isDataTable(dataTable)){
                        dataTable.DataTable().destroy();
                        dataTable.empty();
                    }

                    statisticChart.tableConfig.columns = [];
                    statisticChart.tableConfig.data = [];

                    switch (statisticChart.stat) {
                        case 'super-commissions-downline':
                        case 'avg-super-commissions-downline':
                        case 'revenue-introduced-users':
                            dtColumnDefs.push({
                                'targets': [-3],
                                'class': 'text-right main-color',
                            });
                            dtColumnDefs.push({
                                'targets': [-1],
                                'class': 'text-right',
                                'render': function (data, type, row, meta) {
                                    if(type == 'display' || type == 'filter') {
                                        return (data >= 0 ? '▲ +' : '▼ ') + statisticChart.formatter.format(data) + '%';
                                    }

                                    return data;
                                }
                            });
                            dtColumnDefs.push({
                                'targets': [-2, -3],
                                'render': function (data, type, row, meta) {
                                    if(type == 'display' || type == 'filter') {
                                        return statisticChart.formatter.format(data) + '€';
                                    }

                                    return data;
                                }
                            });
                            dtTotalRow = true;
                            break;
                        case 'count-downline-orders':
                            dtColumnDefs.push({
                                'targets': [-3],
                                'class': 'text-right main-color',
                            });
                            dtColumnDefs.push({
                                'targets': [-1],
                                'class': 'text-right',
                                'render': function (data, type, row, meta) {
                                    if(type == 'display' || type == 'filter') {
                                        return (data >= 0 ? '▲ +' : '▼ ') + statisticChart.formatter.format(data) + '%';
                                    }

                                    return data;
                                }
                            });
                            dtColumnDefs.push({
                                'targets': [-2, -3],
                                'render': function (data, type, row, meta) {
                                    if(type == 'display' || type == 'filter') {
                                        return statisticChart.formatterInteger.format(data);
                                    }

                                    return data;
                                }
                            });
                            dtTotalRow = true;
                            dtTotalRowSymbol = '';
                            dtTotalRowFormatter = statisticChart.formatterInteger.format;
                            break;
                        case 'count-introduced-users':
                            dtColumnDefs.push({
                                'targets': [2],
                                'render': function (data, type, row, meta) {
                                    if(type == 'display' || type == 'filter') {
                                        var month = data.split('/');

                                        return month[1] + '/' + month[0];
                                    }

                                    return data;
                                }
                            });
                            break;
                        case 'super-commissions-personal':
                            dtColumnDefs.push({
                                'targets': [-3],
                                'class': 'text-right main-color',
                            });
                            dtColumnDefs.push({
                                'targets': [-1],
                                'class': 'text-right',
                                'render': function (data, type, row, meta) {
                                    if(type == 'display' || type == 'filter') {
                                        return (data >= 0 ? '▲ +' : '▼ ') + statisticChart.formatter.format(data) + '%';
                                    }

                                    return data;
                                }
                            });
                            dtColumnDefs.push({
                                'targets': [-2, -3],
                                'render': function (data, type, row, meta) {
                                    if(type == 'display' || type == 'filter') {
                                        return statisticChart.formatter.format(data) + '€';
                                    }

                                    return data;
                                }
                            });
                            dtColumnDefs.push({
                                'targets': [0, 1],
                                'render': function (data, type, row, meta) {
                                    if(type == 'display' || type == 'filter') {
                                        var month = data.split('/');

                                        return month[1] + '/' + month[0];
                                    }

                                    return data;
                                }
                            });
                            dtTotalRow = true;
                            break;
                    }

                    if(dtTotalRow){
                        var dtFooterHtml = '<tfoot><tr>';
                        var formatedVal = '';
                        var colspan = 0;
                        for (var c = 0; c < dtColumnsLength; c++) {
                            if(c == dtMainTotalColumn) {
                                formatedVal = _t('Total');
                                dtFooterHtml += '<th colspan="' + colspan + '" class="text-right">' + formatedVal + '</th>';
                                formatedVal = dtTotalRowFormatter(dtMainTotal) + dtTotalRowSymbol;
                                dtFooterHtml += '<th>' + formatedVal + '</th>';
                            }else{
                                colspan++;
                            }
                        }
                        dtFooterHtml += '</tr></tfoot>';
                        dataTable.append(dtFooterHtml);
                    }

                    dataTable.DataTable($.extend(true, {}, statisticChart.tableConfig, {
                        "columns": dtColumns,
                        "data": dtData,
                        "order": dtOrder,
                        "columnDefs": dtColumnDefs,
                        "createdRow": function( row, data, dataIndex ) {
                            if(dtFilterColumn){
                                if (data[dtFilterColumn] == _t('Main') ) {
                                    $(row).addClass( 'main-color');
                                } 
                            }
                        }
                    }));

                    dataTable.on('page', function () {
                            console.log("dd");
                    } );

                }
            },
            drawLineChart: function(statisticFilter, data, formatter, symbol){
                var statisticChart = this;

                var datasets = [{
                    xAxisID: 'main',
                    fill: false,
                    data: data.main[0].data,
                    label: data.main[0].label,
                    backgroundColor: statisticChart.colors.green,
                    borderColor: statisticChart.colors.green,
                    borderWidth: 1
                }];

                statisticChart.chartConfig.data.labels = [];

                $.extend(true, statisticChart.chartConfig, {
                    type: 'line',
                    data: {
                        labels: statisticChart.xAxes,
                        datasets: datasets
                    },
                    options: {
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    var value =  formatter(tooltipItem.yLabel);
                                    return data.datasets[tooltipItem.datasetIndex].label +': ' + value + symbol;
                                }
                            }
                        }
                    }
                });

            },
            drawBarChart: function(statisticFilter, data, formatter, symbol){
                var statisticChart = this;

                var datasets = [];
                $.each(data.main, function(index, item){
                    datasets.push({
                        xAxisID: 'main',
                        fill: false,
                        stack: 'main',
                        data: item.data,
                        label: item.label,
                        backgroundColor: statisticChart.colors.green,
                        borderColor: statisticChart.colors.green,
                        borderWidth: 1
                    });
                });
                statisticChart.chartConfig.data.labels = [];

                $.extend(true, statisticChart.chartConfig, {
                    type: 'bar',
                    data: {
                        labels: statisticChart.xAxes,
                        datasets: datasets
                    },
                    options: {
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    var value =  formatter(tooltipItem.yLabel);
                                    return data.datasets[tooltipItem.datasetIndex].label +': ' + value + symbol;
                                },
                            }
                        },
                        legend: {
                            labels: {
                                userPointStylw: false
                            }
                        },
                        scales: {
                            xAxes: [{
                                offset: true,
                                stacked: true
                            },{
                                offset: true,
                                stacked: true
                            }],
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                    callback: function(value) {if (value % 1 === 0) {return value;}}
                                }
                            }]
                        }
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/widgets/statistics-super-commissions/statisticChart.vue